// Estilos compartidos para el PDF de Orden de Trabajo.
// Pensado para impresión A4: padding en mm, fuente reducida, printColorAdjust
// forzado para que los grises/colores se respeten en la impresión final.

export const S = {
  page: {
    padding: '12mm 15mm',
    backgroundColor: 'white',
    color: '#111',
    fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
    fontSize: '8.5px',
    lineHeight: '1.4',
    width: '210mm',
    boxSizing: 'border-box',
    printColorAdjust: 'exact',
    WebkitPrintColorAdjust: 'exact',
  },
  label: {
    color: '#888',
    fontSize: '7px',
    textTransform: 'uppercase',
    letterSpacing: '0.6px',
    marginBottom: '1mm',
    display: 'block',
  },
  value: {
    color: '#111',
    fontWeight: '500',
    fontSize: '8.5px',
  },
  hrLight: { border: 'none', borderTop: '1px solid #e5e5e5', margin: '3mm 0' },
  hrDark: { border: 'none', borderTop: '2px solid #111', margin: '4mm 0' },
};

export const statusLabels = {
  pendiente_recibir: 'Pendiente Recibir',
  recibida: 'Recibida',
  cuarentena: 'Cuarentena',
  en_taller: 'En Taller',
  reparado: 'Reparado',
  validacion: 'Validación',
  enviado: 'Enviado',
  garantia: 'Garantía',
  cancelado: 'Cancelado',
  reemplazo: 'Reemplazo',
  irreparable: 'Irreparable',
};
